/// <amd-module name="Build/Common/Artifacts/Source" />
import { BuildArtifact } from "Build/Client/Contracts/Build";
import { IBuildRestClient } from "Build/Client/RestClient/Build";

export interface IArtifactsSourceOptions {
    projectId: string;
    client: IBuildRestClient;
}

export class ArtifactsSource {
    private _client: IBuildRestClient;
    private _projectId: string;

    constructor(options: IArtifactsSourceOptions) {
        this._client = options.client;
        this._projectId = options.projectId;
    }

    public getArtifacts(buildId: number): Promise<BuildArtifact[]> {
        return this._client.getArtifacts(this._projectId, buildId).then(ArtifactsSource.sortArtifacts);
    }

    public getArtifact(buildId: number, name: string) {
        return this._client.getArtifact(this._projectId, buildId, name);
    }

    public static sortArtifacts = (artifacts: BuildArtifact[]) => {
        return (artifacts || []).sort((a, b) => {
            if (a.name > b.name) {
                return 1;
            }
            if (a.name < b.name) {
                return -1;
            }
            return 0;
        });
    }
}
